import { OpenDialogAddEditHelpComponent } from './../../dialog/open-dialog-add-edit-help/open-dialog-add-edit-help.component';
import { HelpService } from './../../../shared/services/help/help.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatatableBaseComponent } from 'app/shared/components/datatable-base.component';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { OpenDialogHelpComponent } from 'app/components/dialog/open-dialog-help/open-dialog-help.component';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-admin-help',
  templateUrl: './admin-help.component.html',
  styleUrls: ['./admin-help.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])
  ]
})
export class AdminHelpComponent extends DatatableBaseComponent implements OnInit {

  clubCode: any;
  title: string;

  helps: any[] = [];
  dataSource: MatTableDataSource<any>;

  displayedColumns = ['videoHelpKey', 'location', 'title', 'description', 'nbrVideos', 'actions'];

  isLoading = false;


  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  searchForm: UntypedFormGroup;
  valueInput: string;

  expandedElement: null;
  keyExpanded = null;

  constructor(
    protected uiSrv: UiService,
    private formBuilder: UntypedFormBuilder,
    private faIconService: FaiconService,
    private tooltipSrv: TooltipService,
    private dialog: MatDialog,
    private helpSrv: HelpService
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.initComponent();
  }

  private async initComponent() {

    this.title = 'Liste des aides vidéos';

    this.isLoading = true;
    this.initForm();
    this.initSubscriptions();
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private initSubscriptions(): void {

    this.addSubscription(
      this.helpSrv.helpsListChanged.subscribe(helpsFromSrv => {
        this.isLoading = false;
        this.helps = helpsFromSrv;
        this.initTable();
      })
    );

    this.gethelps();

  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.helps);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = this.helps.length;
    this.isLoading = false;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getTooltip(value: string): string {
    return this.tooltipSrv.getTooltip(value);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  openDialogHelp(helpVideoKey, help) {
    this.dialog.open(OpenDialogHelpComponent, {
      data: { helpVideoKey: helpVideoKey, help: help },
      width: '60%',
      maxHeight: '90%'
    });
  }

  gethelps() {
    this.helpSrv.gethelps().subscribe();
  }

  openDialogAddEditHelp(action, help?) {
    const dialogRef = this.dialog.open(OpenDialogAddEditHelpComponent, {
      data: { action: action, motherHelp: help },
      width: '600px',
      height: '375px'
    });

    dialogRef.afterClosed().subscribe({
      next: () => this.gethelps()
    });
  }

  expandRow(elementSelected, event: Event): void {
    event.stopPropagation();
    this.keyExpanded = elementSelected.videoHelpKey;

    if (this.expandedElement === elementSelected) {
      this.expandedElement = null;
      this.keyExpanded = null;
    } else {

      this.expandedElement = elementSelected;
    }
  }

}
